<!-- Loading -->
<div *ngIf="loading" class="min-h-[70vh] flex items-center justify-center">
  <div class="flex flex-col items-center gap-3">
    <svg class="animate-spin h-8 w-8 text-[#600b0b]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
    </svg>
    <p class="text-sm text-gray-400">Loading order details...</p>
  </div>
</div>

<!-- Thank You Content -->
<div *ngIf="!loading" class="min-h-[70vh] flex items-center justify-center px-4 py-12">
  <div class="max-w-lg w-full text-center">

    <!-- Success Icon -->
    <div class="mx-auto w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mb-6">
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-green-600">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </div>

    <h1 class="text-3xl font-medium text-gray-800 mb-2" style="font-family: 'Roboto Slab', serif">Thank You!</h1>
    <p class="text-gray-500 mb-6">Your order has been placed successfully.</p>

    <!-- Order ID -->
    <div *ngIf="orderId" class="inline-block bg-gray-50 border border-gray-200 rounded-xl px-6 py-3 mb-6">
      <p class="text-[10px] font-bold uppercase tracking-wider text-gray-400 mb-1">Order ID</p>
      <p class="text-lg font-bold text-[#600b0b] font-mono">{{ orderId }}</p>
    </div>

    <!-- Estimated Delivery -->
    <div class="bg-green-50 border border-green-200 rounded-xl p-4 mb-6">
      <div class="flex items-center justify-center gap-2 text-green-700">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle>
        </svg>
        <span class="text-sm font-medium">Estimated Delivery: {{ estimatedDelivery }}</span>
      </div>
    </div>

    <!-- Order Items (if loaded) -->
    <div *ngIf="order?.items?.length > 0" class="bg-white border border-gray-100 rounded-xl p-4 mb-6 text-left">
      <p class="text-[10px] font-bold uppercase tracking-wider text-gray-500 mb-3">Order Items</p>
      <div class="space-y-3">
        <div *ngFor="let item of order.items" class="flex items-center gap-3">
          <div class="w-12 h-12 rounded-lg overflow-hidden bg-gray-50 shrink-0">
            <img [src]="item.image" [alt]="item.name" class="w-full h-full object-cover" />
          </div>
          <div class="flex-grow min-w-0">
            <p class="text-sm font-medium text-gray-800 truncate">{{ item.name }}</p>
            <p class="text-xs text-gray-400">Qty: {{ item.quantity }}</p>
          </div>
          <p class="text-sm font-bold text-gray-800 shrink-0">&#8377;{{ (item.price * item.quantity).toFixed(0) }}</p>
        </div>
      </div>
      <div *ngIf="order.grand_total" class="mt-3 pt-3 border-t border-gray-100 flex justify-between">
        <span class="text-sm font-bold text-gray-700">Total Paid</span>
        <span class="text-lg font-bold text-[#600b0b]">&#8377;{{ order.grand_total.toFixed(0) }}</span>
      </div>
    </div>

    <!-- Error -->
    <div *ngIf="error" class="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-6">
      <p class="text-sm text-amber-700">{{ error }}</p>
    </div>

    <!-- Actions -->
    <div class="space-y-3">
      <button (click)="router.navigate(['/listing'])"
        class="w-full bg-[#600b0b] text-white py-4 rounded-xl font-bold uppercase tracking-widest text-xs hover:bg-[#8c1c1c] transition-colors shadow-lg">
        Continue Shopping
      </button>
      <button (click)="router.navigate(['/'])"
        class="w-full border border-gray-200 text-gray-600 py-3 rounded-xl text-xs font-bold uppercase tracking-wider hover:border-[#600b0b] hover:text-[#600b0b] transition-colors">
        Back to Home
      </button>
    </div>
  </div>
</div>
